/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";

import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditCategoryPage,
    openViewCategoryPage,
    total
    
  }
) => (
  <>
    <>
{/* 
    <a
        title="View Category"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
       onClick={() => openViewCategoryPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Add-user.svg")}
          />
        </span>
      </a>  */}

      <a
        title="Edit Category"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditCategoryPage(row.id, total)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </a> 

    </>
  </>
);
